// components/ProductBasicInfo.tsx
import React from "react";
import Column from "@components/column";
import Row from "@components/row";
import Fields from "@components/fields";
import FieldWrapper from "@components/wrapper/field-wrapper";
import Typography from "@components/typography";
import theme from "@utils/theme";
import { Helper } from "@utils/index";
import { MultiSelect } from "@components/multi-select";
import { useSearchParams } from "react-router-dom";

interface ProductBasicInfoProps {
  values: any;
  setFieldValue: (field: string, value: any) => void;
  categoryOptions: any[];
  subCategoryOptions: any[];
  brandOptions: any[];
  units: any[];
  fetchSubCategories: (parentId: string) => void;
  isPureVeg?: boolean;
}

export const ProductBasicInfo: React.FC<ProductBasicInfoProps> = ({
  values,
  setFieldValue,
  categoryOptions,
  subCategoryOptions,
  brandOptions,
  units,
  fetchSubCategories,
  isPureVeg,
}) => {
  const [searchParams] = useSearchParams();
  const moduleParam = searchParams.get("module")?.toLowerCase() || "";
  const isFoodOrGrocery = moduleParam === "food" || moduleParam === "grocery";
  return (
    <FieldWrapper styleWrapper="width:98%">
      <Typography styleText="font-size:16px;font-weight:600;margin-bottom:10px">
        Store And Category Info
      </Typography>
      <Row styleRow="row-gap:10px">
        <Fields.DropDown
          name="category"
          label="Category"
          options={categoryOptions}
          placeholder="--Select Category--"
          styleInput="width:96%"
          titleAsKey="name"
          valueAsKey="id"
          onChange={(val) => {
            setFieldValue("category", val);
            setFieldValue("subCategory", []);
            fetchSubCategories(val);
          }}
          hasSearch={true}
        />

        <Fields.DropDown
          isMultiple
          name="subCategory"
          label="Sub Category"
          disabled={!values.category}
          options={subCategoryOptions}
          placeholder="--Select Sub Category--"
          styleInput="width:96%"
          titleAsKey="name"
          valueAsKey="id"
        />
        <Fields.DropDown
          name="brand"
          label="Brand"
          options={brandOptions}
          placeholder="--Select Brand--"
          styleInput="width:96%"
          titleAsKey="name"
          valueAsKey="id"
        />
      </Row>
      <br />
      <Row styleRow="row-gap:10px">
        <div style={{ flex: 1 }}>
          <Fields.DropDown
            name="unit"
            label="Unit"
            options={units}
            placeholder="--Select Unit--"
            styleInput="width:96%"
            titleAsKey="name"
            valueAsKey="name"
          />
        </div>
        <div style={{ flex: 1 }}>
          <Fields.DropDown
            // disabled={!isFoodOrGrocery}
            name="foodType"
            label="Select Type"
            placeholder="--Select Type--"
            options={[
              { id: "veg", name: "Veg" },
              { id: "non-veg", name: "Non-Veg" },
              { id: "halal", name: "Halal" },
              { id: "none", name: "None of the above" },
            ].filter((option) =>
              isPureVeg
                ? option.id !== "non-veg" && option.id !== "halal"
                : true,
            )}
            titleAsKey="name"
            valueAsKey="id"
            styleInput="width:96%"
          />
        </div>
        <div style={{ flex: 1 }}>
          <Fields.DropDown
            name="note"
            label="Required Notes"
            placeholder="--Select Type--"
            options={[
              { id: "Text", key: "Text Notes" },
              { id: "Prescriptions", key: "Prescriptions" },
              { id: "Both", key: "Both" },
            ]}
            titleAsKey="key"
            valueAsKey="id"
            styleInput="width:96%"
          />
        </div>

        <div style={{ flex: 1, position: "relative" }}>
          <Fields.Input name="productSKU" label="SKU" placeholder="Enter SKU" />
          <button
            type="button"
            onClick={() => {
              const sku = Helper.generateSku(values.name);
              setFieldValue("productSKU", sku);
            }}
            style={{
              position: "absolute",
              top: "29px",
              right: "0px",
              padding: "6px 12px",
              backgroundColor: theme.colors.primary,
              color: "white",
              border: "none",
              borderRadius: "6px",
              fontSize: "12px",
              fontWeight: "500",
              cursor: "pointer",
              transition: "all 0.2s ease",
              height: "39px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minWidth: "80px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            }}
            onMouseOver={(e: any) => {
              e.target.style.backgroundColor = theme.colors.primaryDark;
              e.target.style.transform = "translateY(-1px)";
              e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.15)";
            }}
            onMouseOut={(e: any) => {
              e.target.style.backgroundColor = theme.colors.primary;
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 1px 3px rgba(0,0,0,0.1)";
            }}
            onMouseDown={(e: any) => {
              e.target.style.transform = "translateY(0)";
              e.target.style.boxShadow = "0 1px 2px rgba(0,0,0,0.1)";
            }}
            onMouseUp={(e: any) => {
              e.target.style.transform = "translateY(-1px)";
              e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.15)";
            }}
          >
            Generate
          </button>
        </div>
      </Row>
      <br />
      <Row styleRow="row-gap:10px">
        <div style={{ flex: 1 }}>
          <Fields.Switch label="Show in App" name="showInApp" />
        </div>
        {moduleParam === "pharma" && (
          <div style={{ flex: 1 }}>
            <Fields.Switch
              label="Prescription Required"
              name="prescriptionRequired"
            />
          </div>
        )}
      </Row>
    </FieldWrapper>
    
  );
};
